<span class="time-range-text">
  <ftr-date class="time-range-text__start" [date]="timeRange.start" [format]="format"></ftr-date>
  @if (isOngoing) {
    - now
  } @else {
    {{ divider }} <ftr-date class="time-range-text__end" [date]="timeRange.end" [format]="format"></ftr-date>
  }
</span>
